'use es6';

import _ from 'underscore';
import I18n from 'I18n';
import classNames from 'classnames';
import { fromJS } from 'immutable';
import GoodSubTypes from '../../constants/GoodSubTypes';
import ManagePurchasesColumns from '../../constants/ManagePurchasesColumns';
import PaymentMethods from '../../constants/PaymentMethods';
import RowDeliveryState from '../../constants/RowDeliveryState';
import SortOrderOptions from '../../constants/SortOrderOptions';
import HubspotUrls from '../../constants/HubspotUrls';
import { isSystemPage } from '../utils';
import { getFriendlyCategoryFilterName } from '../langUtils';
import RequestStatusTypes from '../../constants/RequestStatusTypes';
import GoodSubTypeGroups from '../../constants/GoodSubTypeGroups';
import { templateOptions } from '../sidebarUtils';
import { isCanceled } from 'marketplace-lib/utils/refunds';
var USER_GUIDES = HubspotUrls.USER_GUIDES;
export function generatePurchasedGoodsKeyForChildGood(_ref) {
  var childId = _ref.childId,
      parentId = _ref.parentId;
  return "" + childId + parentId;
}
export function getCreateButtonText(subType) {
  return I18n.text("managePurchases.dropdown.createOption." + subType);
}

function filterByProductType(productTypeFilter, purchasedGoods, goodId) {
  if (productTypeFilter === GoodSubTypes.ALL) {
    return true;
  } else if (productTypeFilter === GoodSubTypeGroups.TEMPLATES) {
    return templateOptions.has(purchasedGoods.getIn([goodId, 'subType']));
  } else {
    return purchasedGoods.getIn([goodId, 'subType']) === productTypeFilter;
  }
}

function filterBySearch(currentSearchFilter, purchasedGoods, goodId) {
  var filter = currentSearchFilter.toLowerCase();

  if (filter === '') {
    return true;
  }

  return purchasedGoods.getIn([goodId, ManagePurchasesColumns.PRODUCT_NAME]).toLowerCase().indexOf(filter) !== -1;
}

function filterByDeliveryStatus(deliveryStatusFilter, purchasedGoods, goodId) {
  var deliveryStatus = purchasedGoods.getIn([goodId, 'deliveryStatus']);

  switch (deliveryStatusFilter) {
    case 'uninstalled':
      return deliveryStatus === RowDeliveryState.UNINSTALLED;

    case 'failed':
      return deliveryStatus === RequestStatusTypes.FAILED;

    case 'installed':
      return deliveryStatus !== RowDeliveryState.UNINSTALLED && deliveryStatus !== RequestStatusTypes.FAILED;

    default:
      return true;
  }
}

function getTranslatedTextIfSortingByType(sortByField, val) {
  if (sortByField === ManagePurchasesColumns.PRODUCT_TYPE) {
    return getFriendlyCategoryFilterName(val);
  }

  return val;
}

export function sortAndFilterGoods(purchasedGoodsDisplayOrder, purchasedGoods, currentSearchFilter, sortBy, sortOrder, productTypeFilter, deliveryStatusFilter) {
  return purchasedGoodsDisplayOrder.filter(filterBySearch.bind(null, currentSearchFilter, purchasedGoods)).filter(filterByProductType.bind(null, productTypeFilter, purchasedGoods)).filter(filterByDeliveryStatus.bind(null, deliveryStatusFilter, purchasedGoods)).sort(function (goodId1, goodId2) {
    var val1 = purchasedGoods.getIn([goodId1, sortBy]);
    var val2 = purchasedGoods.getIn([goodId2, sortBy]);
    val1 = getTranslatedTextIfSortingByType(sortBy, val1);
    val2 = getTranslatedTextIfSortingByType(sortBy, val2);
    var comparisonResult = 0;

    if (_.isString(val1)) {
      comparisonResult = val1.localeCompare(val2);
    } else {
      if (val1 > val2) {
        comparisonResult = 1;
      } else if (val2 > val1) {
        comparisonResult = -1;
      }
    }

    if (sortOrder === SortOrderOptions.DESC) {
      comparisonResult *= -1;
    }

    return comparisonResult;
  });
}
export function isValidPaymentType(paymentType) {
  return _.contains(PaymentMethods, paymentType);
}
export function getGoodFromId(goods, goodId) {
  return goods.find(function (good) {
    return good.get('goodId') === goodId;
  });
}
export function getFirstPendingGood(purchasedGoodsDisplayOrder, purchasedGoods) {
  return purchasedGoodsDisplayOrder.find(function (goodId) {
    return purchasedGoods.getIn([goodId, 'deliveryStatus']) === RequestStatusTypes.PENDING;
  });
}

function getDeliveryStateClass(rowDeliveryState) {
  switch (rowDeliveryState) {
    case RowDeliveryState.DELIVERY_SUCCEEDED_CONFIRMED_BY_POLLING:
      return 'delivery-succeeded';

    case RowDeliveryState.DELIVERY_PENDING_AND_POLLING_STATUS:
    case RowDeliveryState.DELIVERY_PENDING_AND_NOT_POLLING_STATUS:
      return 'delivery-pending';

    case RowDeliveryState.DELIVERY_FAILED:
      return 'delivery-failed';

    default:
      return '';
  }
}

export function getRowClassName(rowDeliveryState, isActiveGood, isDropdownOpen) {
  return classNames("pointer integrate-purchased-good-row purchased-good-row", getDeliveryStateClass(rowDeliveryState), isActiveGood && "active", isDropdownOpen && 'dropdown-open');
}
export function getGoodDeliveryState(goodDeliveryStatus, isPollingGoodBool, pollingGoodStatus) {
  if (isPollingGoodBool) {
    switch (pollingGoodStatus) {
      case RequestStatusTypes.SUCCEEDED:
        return RowDeliveryState.DELIVERY_SUCCEEDED_CONFIRMED_BY_POLLING;

      case RequestStatusTypes.PENDING:
        return RowDeliveryState.DELIVERY_PENDING_AND_POLLING_STATUS;

      case RequestStatusTypes.FAILED:
        return RowDeliveryState.DELIVERY_FAILED;

      default:
        return '';
    }
  }

  switch (goodDeliveryStatus) {
    case RequestStatusTypes.SUCCEEDED:
      return RowDeliveryState.DELIVERY_SUCCEEDED_BEFORE_LAST_PAGE_LOAD;

    case RequestStatusTypes.PENDING:
      return RowDeliveryState.DELIVERY_PENDING_AND_NOT_POLLING_STATUS;

    case RequestStatusTypes.FAILED:
      return RowDeliveryState.DELIVERY_FAILED;

    case RowDeliveryState.UNINSTALLED:
      return RowDeliveryState.UNINSTALLED;

    case RowDeliveryState.REFUNDED:
      return RowDeliveryState.REFUNDED;

    default:
      return '';
  }
}
export function hasDeliverySucceeded(goodDeliveryState) {
  return goodDeliveryState === RowDeliveryState.DELIVERY_SUCCEEDED_CONFIRMED_BY_POLLING || goodDeliveryState === RowDeliveryState.DELIVERY_SUCCEEDED_BEFORE_LAST_PAGE_LOAD || goodDeliveryState === RowDeliveryState.UNINSTALLED || goodDeliveryState === RowDeliveryState.REFUNDED;
}
export function hasCustomerReviewedGood(good) {
  return !!good.get('review');
}
export function hasRequestedRefund(refund) {
  return !!refund && !isCanceled(refund);
}
export function isGoodRefundable(good) {
  return !good.get('parentId') && !good.get('isFree') && !hasRequestedRefund(good.get('refund'));
}
export function canCreateAsset(good) {
  return (good.get('subType') === GoodSubTypes.LANDING_PAGES || good.get('subType') === GoodSubTypes.SITE_PAGES || good.get('subType') === GoodSubTypes.EMAIL_TEMPLATES) && !!good.get('templatePath') && good.get('deliveryStatus') !== RowDeliveryState.UNINSTALLED;
}
export function getUserGuideLinkInfoForSubType(subType) {
  if (subType === GoodSubTypes.LANDING_PAGES) {
    return {
      text: I18n.text('managePurchases.detailsRow.userGuideLink.landingPage'),
      url: USER_GUIDES.LANDING_PAGE
    };
  } else if (subType === GoodSubTypes.BLOG_TEMPLATES) {
    return {
      text: I18n.text('managePurchases.detailsRow.userGuideLink.blog'),
      url: USER_GUIDES.BLOG
    };
  } else if (subType === GoodSubTypes.EMAIL_TEMPLATES) {
    return {
      text: I18n.text('managePurchases.detailsRow.userGuideLink.email'),
      url: USER_GUIDES.EMAIL
    };
  } else if (subType === GoodSubTypes.SITE_PAGES || isSystemPage(subType)) {
    return {
      text: I18n.text('managePurchases.detailsRow.userGuideLink.website'),
      url: USER_GUIDES.WEBSITE
    };
  }

  return {
    text: I18n.text('managePurchases.detailsRow.userGuideLink.general'),
    url: USER_GUIDES.GENERAL
  };
}
export function isPollingGood(pollingGoodId, goodId) {
  return pollingGoodId === goodId || pollingGoodId === Number(goodId);
}
export function getChildTemplatePath(goodDeliverInfo, child) {
  if (!_.isArray(goodDeliverInfo)) {
    return '';
  }

  var childTemplateIdAndPath = _.find(goodDeliverInfo, function (idAndPath) {
    return idAndPath.goodVersionId === Number(child.goodVersionId);
  });

  return childTemplateIdAndPath ? childTemplateIdAndPath.destinationLocator : '';
}
export function getChildDestinationId(goodDeliverInfo, child) {
  if (!_.isArray(goodDeliverInfo)) {
    return '';
  }

  var childTemplateIdAndPath = _.find(goodDeliverInfo, function (idAndPath) {
    return idAndPath.goodVersionId === Number(child.goodVersionId);
  });

  return childTemplateIdAndPath ? childTemplateIdAndPath.destinationId : '';
}
export function getMostRecentGoodDeliverInfo(goodDeliverInfo, key) {
  return _.isArray(goodDeliverInfo) && goodDeliverInfo.length && goodDeliverInfo[0][key] || '';
}
export function getTemplatePathForGoodNotInPack(goodDeliverInfo) {
  return getMostRecentGoodDeliverInfo(goodDeliverInfo, 'destinationLocator');
}
export function getPackChildrenInUseDestinationIds(response) {
  return fromJS(Object.keys(response)).filter(function (destinationId) {
    return response[destinationId].length;
  });
}
export function getDestinationIdForGoodNotInPack(goodDeliverInfo) {
  return getMostRecentGoodDeliverInfo(goodDeliverInfo, 'destinationId');
}
export function getPackChildrenDestinationIds(goodToRefund, purchasedGoods) {
  return goodToRefund.get('packChildrenDisplayOrder').map(function (childId) {
    return purchasedGoods.getIn([generatePurchasedGoodsKeyForChildGood({
      childId: childId,
      parentId: goodToRefund.get('goodId')
    }), 'destinationId']);
  });
}
export function getPackChildrenInUse(childrenInUseDestinationIds, goodToRefund, purchasedGoods) {
  return goodToRefund.get('packChildrenDisplayOrder').filter(function (childId) {
    return childrenInUseDestinationIds.includes(purchasedGoods.getIn([generatePurchasedGoodsKeyForChildGood({
      childId: childId,
      parentId: goodToRefund.get('goodId')
    }), 'destinationId']));
  }).map(function (childId) {
    return purchasedGoods.get(generatePurchasedGoodsKeyForChildGood({
      childId: childId,
      parentId: goodToRefund.get('goodId')
    }));
  });
}
export function getIsSiteOrLandingPage(subType) {
  return subType === GoodSubTypes.LANDING_PAGES || subType === GoodSubTypes.SITE_PAGES;
}
export function getHasChildSiteOrLandingPage(parentId, purchasedGoods) {
  return purchasedGoods.filter(function (good) {
    return good.get('parentId') === parentId;
  }).some(function (good) {
    return getIsSiteOrLandingPage(good.get('subType'));
  });
}